module.exports = __webpack_public_path__ + "static/media/gmd2.1c9a8006.png";